import { HomePage } from '@factory5/platform-web'

export default HomePage
